import {ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BaseComponent, FilterModel, GLOBAL, Page} from "common-shared";
import {take, takeUntil} from "rxjs/operators";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {saveAs} from 'file-saver';
import {ManufacturingItemService} from "../manufacturing-item.service";
import {FilterMetadata} from "primeng/api";
import {ItemListFilter} from "web-shared";

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styles: [
  ]
})
export class ItemListComponent extends BaseComponent implements OnInit {
  filter: FilterModel<ItemListFilter> = new FilterModel<ItemListFilter>({
    Data: new ItemListFilter(),
    Page: new Page()
  });
  defaultFilter: {
    [s: string]: FilterMetadata | FilterMetadata[];
  } = {'StatusClv': [{matchMode: 'notEquals', 'value': GLOBAL.Classificators.ItemStatus.Closed}]};
  stateKey: string;
  search$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  activatedRoute = inject(ActivatedRoute);
  Classificators = GLOBAL.Classificators;
  urlForEdit = '/manufacturing/item/edit';
  rowSelectEnabled = false;
  constructor(protected router: Router, private manufacturingItemService: ManufacturingItemService, public changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    FilterModel.ensureCustomFilterApplied(this.activatedRoute.routeConfig?.data['filter'], this.defaultFilter);
    const customStateKey = this.activatedRoute.routeConfig?.data['stateKey'];
    this.stateKey = customStateKey ?? 'item-list-state';
  }

  openEditByItem($event: string) {
    this.router.navigate([this.urlForEdit, $event], {queryParams: {tab: 'general'}});
  }

  goToAdd(){
    this.router.navigate(['./manufacturing/item/add']).catch(reason => console.error(reason));
  }

  saveExcel(action: string): Subscription {
    let observable: Observable<{ fileName: string; data: Blob }>
    switch (action)
    {
      case 'DownloadExcelAllData':
        observable = this.manufacturingItemService.downloadListExcel(this.filter, true);
        break;
      case 'DownloadExcel':
        observable = this.manufacturingItemService.downloadListExcel(this.filter, false);
        break;
      case 'DownloadCompactExcel':
        observable = this.manufacturingItemService.downloadCompactListExcel(this.filter);
        break;
      case 'DownloadCostExcel':
        observable = this.manufacturingItemService.downloadCostListExcel(this.filter);
        break;
    }

    return observable.pipe(take(1), takeUntil(this.componentDestroyed)).subscribe(value => {
      saveAs(value.data, value.fileName);
    });
  }

  runChangeDetector() {
    this.changeDetector.detectChanges();
  }
}
